import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from './ThemeProvider';

interface LawyerThemeWrapperProps {
  children: ReactNode;
}

// Rutas que son para abogados y deben tener dark mode
const LAWYER_ROUTES = [
  '/lawyer',
  '/marketplace',
  '/metrics',
  '/pricing',
  '/payment/finish',
  '/legalbot/payment/finish',
  '/conversation_inspector',
  '/validate-lawyers',
  '/legalbot/configurations',
  '/legalbot/dashboard',
  '/legalbot/conversations',
  '/legalbot/cases',
  '/legalbot/copilot',
  '/legalbot/pricing',
  '/legalbot/plan',
  '/legalbot/notifications',
  '/legalbot/lawyer/:id/profile',
  '/legalbot/lawyer/:id/edit',
  '/legalbot/lawyer/configurations',
  '/legalbot/influencers',
];

// Rutas que son para usuarios/clientes y deben tener dark mode
const USER_ROUTES = [
  '/user/notifications',
  '/user/cases',
  '/user/cases/summary',
  '/user/cases/create',
  '/user/profile',
  '/user/configurations',
  '/user/chats',
];

// Convierte un patrón con :param en regex y comprueba si pathname coincide
function matchPathPattern(pattern: string, pathname: string): boolean {
  if (!pattern.includes(':')) {
    return pathname === pattern || pathname.startsWith(pattern + '/');
  }
  const regex = new RegExp(
    '^' + pattern.replace(/:[\w]+/g, '[^/]+') + '$'
  );
  return regex.test(pathname);
}

export function LawyerThemeWrapper({ children }: LawyerThemeWrapperProps) {
  const location = useLocation();
  const isLawyerRoute = LAWYER_ROUTES.some(route =>
    matchPathPattern(route, location.pathname)
  );
  const isUserRoute = USER_ROUTES.some(route =>
    location.pathname === route || location.pathname.startsWith(route + '/')
  );

  // Aplicar ThemeProvider en rutas de abogados y usuarios
  if (isLawyerRoute || isUserRoute) {
    return <ThemeProvider>{children}</ThemeProvider>;
  }

  return <>{children}</>;
}

